
import esTranslations from './es';
import enTranslations from './en';
import { Language, TranslationKeys } from '@/types/translations';

export const translations: Record<Language, TranslationKeys> = {
  es: esTranslations,
  en: enTranslations,
};

export const getTranslations = (language: Language): TranslationKeys => {
  return translations[language];
};
